import translations from './i18n.json';
import { translateInComponent } from 'infras/i18n';
import styled from '@emotion/styled';
import { productSecurityPath } from 'presentations/routes/path';
import { mediaMax, spacing } from 'presentations/views/styles';
import ContentItem4 from 'presentations/views/components/molecules/ServiceContentItem4';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import Button from 'presentations/views/components/atoms/Button';

interface Props {
  link?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <>
      <SectionTitle title={t('title')} description={t('description')} />
      <ListContainer1>
        <ListItem2>
          <ContentItem4
            imageUrl="pages/features/security/iso_27001.svg"
            imageWidth={120}
            imageHeight={120}
            title={t('ISO / IEC 27001')}
            description={t('isms text')}
          />
        </ListItem2>
        <ListItem2>
          <ContentItem4
            imageUrl="pages/features/security/ccpa.svg"
            imageWidth={120}
            imageHeight={120}
            title={t('CCPA')}
            description={t('ccpa text')}
          />
        </ListItem2>
      </ListContainer1>
      {props.link && (
        <More>
          <Button color="primary" size="large" href={props.link}>
            {t('more')}
          </Button>
        </More>
      )}
    </>
  );
}

const More = styled.div`
  margin-top: ${spacing(32)};
  text-align: center;
`;
const ListContainer1 = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${spacing(32)};
  row-gap: ${spacing(64)};
  justify-content: space-between;
  /* margin-bottom: ${spacing(64)}; */
  ${mediaMax.tablet} {
    display: block;
  }
`;
const ListItem2 = styled.div`
  height: auto;
  ${mediaMax.tablet} {
    width: 100%;
    margin-bottom: ${spacing(24)};
  }
`;
